module.exports = __webpack_public_path__ + "img/mini.89fe97f9.png";